import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Cache } from './cache.service';
import {
  NewListProductsRequest,
  NewListProductsResponse,
  ListProductTypesRequest,
  ListProductTypesResponse,
  SituViewWebApiClient,
} from 'situview-webapi-client';


@Injectable({
  providedIn: 'root'
})
export class NewProductService {

  listProductsCacheKey: Guid = Guid.create();
  oldListProductsCacheKey: Guid = Guid.create();

  listProductTypesCacheKey: Guid = Guid.create();
  oldListProductTypesCacheKey: Guid = Guid.create();

  constructor(
    private situViewClient: SituViewWebApiClient
  )  {
    this.oldListProductsCacheKey = this.listProductsCacheKey;
  }

  ListProducts(request: NewListProductsRequest, refreshData: boolean = false): Promise<NewListProductsResponse> {
    if (refreshData) {
      this.RefreshListProductsData();
    }

    return this.listProductsInternal(request, this.listProductsCacheKey, this.oldListProductsCacheKey);
  }
  
  RefreshListProductsData() {
    this.oldListProductsCacheKey = this.listProductsCacheKey;
    this.listProductsCacheKey = Guid.create();
  }

  ListProductTypes(refreshData: boolean = false): Promise<ListProductTypesResponse> {
    if (refreshData) {
      this.RefreshListProductTypesData();
    }

    return this.listProductTypesInternal(this.listProductsCacheKey, this.oldListProductsCacheKey);
  }
  
  RefreshListProductTypesData() {
    this.oldListProductTypesCacheKey = this.listProductTypesCacheKey;
    this.listProductTypesCacheKey = Guid.create();
  }

  @Cache({
    duration: 900000
  })
  private listProductsInternal(request: NewListProductsRequest, cacheKey: Guid, oldCacheKey: Guid): Promise<NewListProductsResponse> {
    return this.situViewClient.newListProducts(request);
  }

  @Cache({
    duration: 900000
  })
  private listProductTypesInternal(cacheKey: Guid, oldCacheKey: Guid): Promise<ListProductTypesResponse> {
    return this.situViewClient.listProductTypes(new ListProductTypesRequest());
  }
}
